/**
 * Owner: Masa Bayu
 * File: DiscoverPanel.tsx
 * Date:Time: 2026-09-17 18:42
 * Description: Discover browse — grid · empty state · Spec A.
 */

import { searchMarketplaceCatalog } from '@qx/qxread-core';
import { QxEmptyState } from '../ux';
import { createDemoCatalog } from '../publication/create-demo-catalog';
import { QxBookCard } from './QxBookCard';

export interface DiscoverPanelProps {
  readonly onNavigate: (path: string) => void;
}

export function DiscoverPanel({ onNavigate }: DiscoverPanelProps) {
  const result = searchMarketplaceCatalog(createDemoCatalog(), { sort: 'title_asc' });

  return (
    <section className="route-panel" aria-labelledby="route-title">
      <p className="eyebrow">QXRead · Discover</p>
      <h2 id="route-title">Discover</h2>
      <p>
        Faceted browse of public catalog metadata. Filters refine discovery — they do not grant
        ownership or open QXReader.
      </p>
      {result.cards.length === 0 ? (
        <QxEmptyState
          title="Nothing to discover yet"
          description="The catalog has no public titles in this view."
          actionLabel="Back to Home"
          onAction={() => {
            onNavigate('/');
          }}
        />
      ) : (
        <ul className="catalog-list discovery-rail__list" aria-label="Discover catalog">
          {result.cards.map((card) => (
            <li key={card.publicationId}>
              <QxBookCard card={card} onNavigate={onNavigate} />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
